<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field v-if="user.id !== undefined" label="ID" v-model="user.id" disabled>
        </v-text-field>

        <v-text-field prepend-icon="person" v-model="user.email" name="login" label="Email" :rules="emailRules"
          required>
        </v-text-field>
        <v-text-field prepend-icon="lock" v-model="user.password" name="password" label="Parola"
          type="password"></v-text-field>

        <v-select label="Rol" v-model="user.type" :items="permissionTypes" :rules="requiredRule" required>
        </v-select>

        <v-color-picker v-model="user.color" flat></v-color-picker>

        <v-switch label="Activ" v-model="user.isActive" class="mx-2"></v-switch>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  PERMISSION_LEVEL_ADMIN,
  PERMISSION_LEVEL_TECHNICIAN,
  PERMISSION_LEVEL_TECHNICIAN_ANRE,
  PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB
} from '../../utils/permissions';

export default {
  name: 'user-form',
  props: ['user', 'onSubmit'],
  data() {
    return {
      valid: true,
      permissionTypes: [PERMISSION_LEVEL_ADMIN, PERMISSION_LEVEL_TECHNICIAN, PERMISSION_LEVEL_TECHNICIAN_ANRE, PERMISSION_LEVEL_TECHNICIAN_ANRE_SRB],
      requiredRule: [
        (element) => {
          if (element.trim() === '') return 'Campul trebuie completata.';
          return true;
        },
      ],
      emailRules: [
        (v) => {
          if (!v || v.trim() === '') return true;

          const emailRegex =
            /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
          return emailRegex.test(v) || 'E-mail nu este valid';
        },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style></style>
